import React from "react";

const Loader = () => (
  <div style={{ height: "100vh"}}>
    Loading
  </div>
);

export default Loader;